import React, { useEffect, useState } from 'react';
import { useForm, FormProvider } from 'react-hook-form';
import { useStoreon } from 'storeon/react';

import BlockCustomerInfo from '../../BlockCustomerInfo';
import BlockContactMethod from '../../BlockContactMethod';
import BlockDescribeProblem from '../../BlockDescribeProblem';

import Btn from "../../Btn";
import Info from "../../Info";
import axios from "axios";
import Loader from '../../Loader';

const ServiceRequestForm = ( { id } ) => {
    const [serverResponse , setServerResponse] = useState('');
    const [submitForm , setSubmitForm] = useState(false);

    const methods = useForm( {
        mode: 'all',
        reValidateMode: 'onChange',
        // Default values for field array.
        defaultValues: {
            your_project: [{}],
        },
    } );
    const { errors, trigger, handleSubmit, formState } = methods;

    const onSubmit = ( data ) => {
        const endpointUrl = `${window.location.origin}/sr/api`;
        setSubmitForm(true);

        axios( {
            method: 'post',
            url: endpointUrl,
            data: data,
            config: {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            },
        } )
            .then((response) => {
                if (response.status === 200) {
                    window.location.href = `${window.location.origin}${window.location.pathname.replace( /\/+$/, '' )}/submission`;
                }
            })
            .catch( ( error ) => {
                setServerResponse(error.response.data);
                setSubmitForm(false);
                console.log( error );
            } );
    }
    const { dispatch, groups } = useStoreon( 'groups' );
    /**
     * Trigger form validation on component init.
     * This action will pre-populate errors object.
     */
    useEffect( () => {
        trigger();
    }, [trigger] );
    /**
     * Check form errors and determine if fieldset should be disabled.
     */

    useEffect( () => {
        for ( let i = 1; i < groups.length; i += 1 ) {
            const { fields: groupFields } = groups[i - 1];
            const isValid = !Object.keys( errors ).some( ( item ) => groupFields.includes( item ) );
            if ( groups[i].disabled === isValid ) {
                dispatch( 'CHANGE_FIELDSET_STATE', { id: i, disabled: !isValid } );
            }
        }
    } );

    const handleChatLaunch = () => {
        const launchButton = document.getElementById('launch-chat-btn');

        if (launchButton) {
            launchButton.click();
        }
    };

    return (
        <div className={`service-request-form container`}>
            <FormProvider {...methods}>
                <form onSubmit={handleSubmit( onSubmit )}>
                    <Info styleText={'text-grey b mb-none'}>
                        NOTE: You will need your Sales Order Number (preferred) or product information
                        in order for us to review your request.
                    </Info>
                    <Info styleText={'text-grey'}>
                        Not sure how to find it? <a href="https://anlin.com/locate-order-number/" target="_blank"
                                                    rel="noopener noreferrer">Click here.</a>
                    </Info>
                    <BlockDescribeProblem index={0} idForm={id}/>
                    <BlockCustomerInfo index={1}/>
                    <BlockContactMethod index={2}/>
                    <Btn disabled={!formState.isValid || submitForm}><input type="submit" disabled={!formState.isValid || submitForm} value={'Request Service'}/></Btn>
                    {serverResponse &&  <div className="server-error">{ serverResponse }</div>}
                    <Info styleText={'sms-consent-acknowledgement'}>
                        <p>
                            By providing my phone number and clicking on the “Request Service” button above, I acknowledge and agree to the following:
                        </p>
                            <ul>
                                <li>
                                    That I am providing my express written consent for the limited purpose to receive text messages (e.g. to schedule, confirm a schedule, estimated arrival time, etc. ) from MITER Brands and its affiliates and authorized third parties calling or texting on their behalf, using an automatic telephone dialing system or an artificial or prerecorded voice at the phone number I have provided and for MITER Brands to share my information with such third parties accordingly. I understand that I am providing this consent to receive such telephone calls and texts even if my telephone number is currently listed on any federal, state, local, internal, or corporate Do-Not-Call (“DNC”) Lists. Message and data rates may apply. Message frequency varies. Unsubscribe at any time by replying “STOP”.
                                </li>
                                <li>
                                    I understand that I do not have to agree to receive these types of calls or text messages as a condition of receiving service. I understand that instead of providing consent, I may call <a href="tel:18002877996">800-287-7996</a> to speak with an individual customer care representative.
                                </li>
                            </ul>
                            <p>
                                By submitting this form, I acknowledge and agree to the MITER Brands Privacy Notice <a href="https://anlin.com/content/privacy-notice/" target="_blank" rel="noopener noreferrer">Privacy Notice</a> and <a href="https://anlin.com/content/terms-of-use/" target="_blank" rel="noopener noreferrer">Terms of Use</a>, except as restricted by this limited purpose consent.
                            </p>
                    </Info>
                </form>
            </FormProvider>
            {submitForm && <Loader />}
        </div>
    );
};

export default ServiceRequestForm;
